import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export const StrategyLogicExplanation: React.FC = () => {
    return (
        <div style={{ fontSize: 13, color: '#666', lineHeight: 2, padding: '8px 16px', background: '#fafafa', borderRadius: 8 }}>
            <div style={{ marginBottom: 12 }}>
                <Text strong style={{ fontSize: 14, color: '#333' }}>1. 销售额 (Sales)</Text>
                <ul style={{ marginTop: 4, marginBottom: 0 }}>
                    <li>基础销售额 = 基础日销 × 天数 × 基础有效售价 (扣除 Prime/LD/Coupon 折扣)</li>
                    <li>Promo销售额 = Promo日销 × 天数 × Promo折扣价 (仅 Promo 销量享受 Promo 折扣)</li>
                    <li>总销售额 = 基础销售额 + Promo销售额</li>
                </ul>
            </div>
            <div style={{ marginBottom: 12 }}>
                <Text strong style={{ fontSize: 14, color: '#333' }}>2. 广告费 (Ad Cost)</Text>
                <ul style={{ marginTop: 4, marginBottom: 0 }}>
                    <li>广告出单量 = 基础销量 × 广告占比 (不含 Promo 销量，因 Promo 流量通常来自站外)</li>
                    <li>点击量 = 广告出单量 / CVR</li>
                    <li>广告费 = 点击量 × CPC</li>
                </ul>
            </div>
            <div style={{ marginBottom: 12 }}>
                <Text strong style={{ fontSize: 14, color: '#333' }}>3. 成本与利润 (Cost & Profit)</Text>
                <ul style={{ marginTop: 4, marginBottom: 0 }}>
                    <li>总成本 = 产品成本 + FBA费 + 佣金 + 仓储费 + Coupon费($5固定+2.5%佣金*60%使用率) + 广告费</li>
                    <li>净毛利 = 总销售额 - 总成本</li>
                    <li>净毛利率 = 净毛利 / 总销售额 × 100%</li>
                    <li>定价毛利率 = (净毛利 + 广告费) / 总销售额 × 100% (反映定价策略的毛利空间)</li>
                </ul>
            </div>
            <div>
                <Text strong style={{ fontSize: 14, color: '#333' }}>4. 广告指标 (ACOS / TACOS)</Text>
                <ul style={{ marginTop: 4, marginBottom: 0 }}>
                    <li>ACOS = 广告费 / 广告销售额 × 100% (广告销售额 = 广告出单量 × 实际售价)</li>
                    <li>TACOS = 广告费 / 总销售额 × 100%</li>
                </ul>
            </div>
        </div>
    );
};
